import React, {Component} from 'react';
import 'index.css';
import './Controls.css';
import './MuteBtn.scss';

class MuteBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      targetVolume: 0,
      targetOn: false,
    };
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.volumeLevelRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener('mouseup', this.handleMouseUp);
    document.addEventListener('mousemove', this.handleMouseMove);
  }
  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('mousemove', this.handleMouseMove);
  }
  handleMouseDown(e) {
    e.stopPropagation();
    let node = this.volumeLevelRef.current;
    let rect = node.getBoundingClientRect();
    let v = Math.min(1, Math.max(0, -(e.clientY - rect.top - rect.height) / rect.height));
    this.setState({targetVolume: v, targetOn: true});
    this.props.onVolumeChange(v);
  }
  handleMouseMove(e) {
    e.stopPropagation();
    if (this.state.targetOn) {
      const node = this.volumeLevelRef.current;
      let rect = node.getBoundingClientRect();
      let v = Math.min(1, Math.max(0, -(e.clientY - rect.top - rect.height) / rect.height));
      this.setState({
        targetVolume: v,
      });
      this.props.onVolumeChange(v);
    }
  }
  handleMouseUp(e) {
    e.stopPropagation();
    if (this.state.targetOn) {
      this.setState({targetOn: false});
      this.props.onVolumeChange(this.state.targetVolume);
    }
  }
  render() {
    let btnClass = 'controls-mute-btn controls-btn';
    let clickHandler = this.props.onMute;
    if (this.props.muted) {
      btnClass += ' muted';
      clickHandler = this.props.onUnMute;
    }
    let volumeStyle = {height: this.props.volume * 100 + '%'};
    let targetStyle = {bottom: 'calc(' + this.state.targetVolume * 100 + '% - 5px)'};
    let targetClass = 'controls-mute-btn-volume-target';
    let volumeClass = 'controls-mute-btn-volume';
    if (this.state.targetOn) {
      targetClass += ' on';
      volumeClass += ' show';
    }
    return (
      <span className={btnClass}>
        <div className={volumeClass}>
          <div className="controls-mute-btn-volume-container" onClick={e => e.stopPropagation()}>
            <div className="controls-mute-btn-volume-container-inner">
              <div className="controls-mute-btn-volume-background"></div>
              <div className="controls-mute-btn-volume-level" style={volumeStyle}></div>
              <div className={targetClass} style={targetStyle}></div>
              <div
                className="controls-mute-btn-volume-mask"
                ref={this.volumeLevelRef}
                onMouseDown={this.handleMouseDown}
                onClick={e => e.stopPropagation()}
              ></div>
            </div>
          </div>
        </div>
        <div className="controls-mute-btn-mute" onClick={clickHandler}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
            <path
              id="Union_1"
              data-name="Union 1"
              d="M-795.8,4105H-803v-7h7.2l4.8-4v15Z"
              transform="translate(803 -4094)"
            />
          </svg>
        </div>
      </span>
    );
  }
}
export default MuteBtn;
